<template>
  <div>
    <ul class="days">
      <router-link v-for="(dval, dkey) in days" :key="dkey" :to="'/days/' + dval.id">
        <li>
          <b>{{ dval.formatted }}</b><br>
          <span class="count">
            {{ dval.sessions_count }} Sessions with presentations
          </span>
          <span class="arrow">
            <font-awesome-icon :icon="['fas', 'angle-right']" />
          </span>
        </li>
      </router-link>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  computed: {
    ...mapState(['days']),
  },
  methods: {
    ...mapActions(['getDays']),
  },
  created() {
    this.getDays();
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/colors';
.days {
  padding: 0;
  margin: 0;
  > a {
    > li {
      list-style: none;
      padding: 13px 16px 12px 16px;
      border-bottom: 1px solid #e4e4e4;
      position: relative;
      > .count {
        display: inline-block;
        margin-top: 6px;
      }
      > .arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-13px);
        right: 16px;
        display: inline-block;
        height: 100%;
        font-size: 24px;
        opacity: .3;
      }
    }
    &:hover {
      text-decoration: none;
      > li {
        background: lighten($conference-color, 95%);
        > .arrow {
          opacity: 1;
        }
      }
    }
  }
}
</style>
